import { F0Text } from '@factorialco/f0-react'
import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import type { Option } from 'modules/core/components/Popover/Content'
import { useMemo } from 'modules/core/hooks/useMemo'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { TaskFile } from 'modules/tasks/hooks/useGetTaskFiles'

import File, { type FileOptions } from './File'

interface Props {
  files: TaskFile[]
  loadingFiles: boolean
}

const Attachments = ({ files, loadingFiles }: Props) => {
  const existingFileOptions = (path: string, fileName: string): Option[] => [
    {
      href: path,
      title: i18n.t('common.download_file_name', { name: fileName }),
    },
  ]

  const fileOptions = useMemo(() => {
    if (loadingFiles) return []

    const filesFromTask = (files || []).map((file) => {
      const fileName = file ? file.filename : ''
      const path = buildUrl(`/${file.path}`)
      return {
        fileName,
        file,
        inlinePath: path + '?inline=true',
        newFile: false,
        options: existingFileOptions(path, fileName),
      }
    })

    return filesFromTask as FileOptions[]
  }, [loadingFiles, files.length]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loadingFiles) return <Loading />
  return (
    <Box gap="s16">
      <F0Text variant="label" content={i18n.t('tasks.attached_files')} />
      {fileOptions.length ? (
        <Box gap="s16">
          {fileOptions.map((file, index) => (
            <File key={index} fileOptions={file} />
          ))}
        </Box>
      ) : (
        <Text.Normal color="grey600">{i18n.t('tasks.task_details_no_documents')}</Text.Normal>
      )}
    </Box>
  )
}

export default observer(Attachments)
